import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { Message } from '../../../subcomponents/message/message';
import { MemberRewardListContextInstance } from '../types/context';
export var MemberRewardListMessageType;
(function (MemberRewardListMessageType) {
    MemberRewardListMessageType["NoRewards"] = "NoRewards";
    MemberRewardListMessageType["FailedToLoadData"] = "FailedToLoadData";
})(MemberRewardListMessageType || (MemberRewardListMessageType = {}));
const b = bemClassBuilder('v-member-reward-list-message');
export const MemberRewardListMessage = observer(props => {
    const { messageType } = props;
    const { displayText, assets } = useContext(MemberRewardListContextInstance);
    return (_jsx(Message, Object.assign({ className: b.block({ type: messageType }) }, getMemberRewardListMessageProps(messageType, assets, displayText))));
});
MemberRewardListMessage.displayName = 'MemberRewardListMessage';
const getMemberRewardListMessageProps = (messageType, assets, displayText) => {
    switch (messageType) {
        case MemberRewardListMessageType.NoRewards:
            return {
                iconName: assets.noRewardsIconName,
                title: displayText.noRewardsErrorTitle,
                description: displayText.noRewardsErrorMessage
            };
        case MemberRewardListMessageType.FailedToLoadData:
            return {
                iconName: assets.failedToLoadDataIconName,
                title: displayText.failedToLoadDataTitle,
                description: displayText.failedToLoadDataMessage
            };
        default:
            return undefined;
    }
};
